import { useState } from 'react';

export const useTouchedFields = <F extends string>(
  initial: Record<F, boolean>
) => {
  const [touched, setTouched] = useState<Record<F, boolean>>(initial);
  const markTouched = (field: F) =>
    setTouched(prev => ({ ...prev, [field]: true }));
  return { touched, markTouched };
};
